<template>
  <div id="app">    
    <router-view/>
  </div>
</template>

<script>

import {LoginConfig,CommonConfig} from '@/store/Constraints';

export default {
  name: 'App'  ,
  
  // data() {
  //   return {
  //     polling : null
  //   }
  // },
  // computed: {  
  //   loginState: function() {
  //       return this.$store.getters[LoginConfig.LOGIN_STATE];
  //   },
  // },
  // create(){    
  //   console.log(`App.create -> loginState:${this.loginState}`) 
  //   this.pollingAccessToken()  

  //   // let loader = this.$loading.show();
  //   // // simulate AJAX
  //   // setTimeout(() => {
  //   //   loader.hide()
  //   // },500)        

    


  // },
  // beforeDestroy () {
  //   clearInterval(this.polling)
  // },
  // methods:{
  //   pollingAccessToken(){
  //     console.log(`App.create.pollingAccessToken -> loginState:${this.loginState}`) 
  //     this.polling = setInterval(() => {
  //       console.log(`App.create.pollingAccessToken -> loginState:${this.loginState}`) 
  //       if(this.loginState == false){
  //         let accesToken = localStorage.getItem("accessToken");
  //         if(accesToken){
  //             console.log(`Login.methods.pollingAccessToken -> loginState:${this.loginState} , accesToken : ${accesToken.trim()}`);      
  //             this.$store.dispatch(LoginConfig.LOGIN_DEVICE_EVENT, accesToken.trim())
  //             localStorage.removeItem("accessToken")
  //         }
  //       }
  //     }, 1000)
  //   },
    
  // }
}
</script>

<style>
  @import url('./assets/css/style.css');
</style>



// WEBPACK FOOTER //
// src/App.vue